import { useCallback } from "react";
import useRouter from "domains/navigation/hooks/useRouter";
import {
  Breadcrumb,
  BreadcrumbDivider,
  BreadcrumbItem,
} from "domains/ui/components/Breadcrumb";

import { Spinner } from "@chakra-ui/react";

interface BlendBreadcrumbProps {
  category?: { id: string; label: string };
  subCategory?: { id: string; label: string };
  model?: { id: string; label: string };
  isLoading?: boolean;
}

export default function BlendBreadcrumb({
  category,
  subCategory,
  model,
  isLoading,
}: BlendBreadcrumbProps) {
  const router = useRouter();

  const handleBack = useCallback(() => {
    void router.push({
      pathname: "/compose/new",
      query:
        (category &&
          subCategory &&
          model && {
            categoryId: category.id,
            subCategoryId: subCategory.id,
          }) ||
        (category && subCategory && { categoryId: category.id }) ||
        (category && model && { categoryId: category.id }) ||
        {},
    });
  }, [router, category, subCategory, model]);

  return (
    <Breadcrumb onBack={handleBack}>
      <BreadcrumbItem internalLink="/compose/new">All Models</BreadcrumbItem>

      {category && (
        <>
          <BreadcrumbDivider />
          <BreadcrumbItem
            internalLink={{
              pathname: "/compose/new",
              query: { categoryId: category.id },
            }}
            isDisabled={!subCategory && !model}
          >
            {category.label}
          </BreadcrumbItem>
        </>
      )}

      {category && subCategory && (
        <>
          <BreadcrumbDivider />
          <BreadcrumbItem
            internalLink={{
              pathname: "/compose/new",
              query: { categoryId: category.id, subCategoryId: subCategory.id },
            }}
            isDisabled={!model}
          >
            {subCategory.label}
          </BreadcrumbItem>
        </>
      )}

      {model && (
        <>
          <BreadcrumbDivider />
          <BreadcrumbItem isDisabled>{model.label}</BreadcrumbItem>
        </>
      )}

      {isLoading && (
        <>
          <BreadcrumbDivider />
          <BreadcrumbItem isDisabled>
            <Spinner size="sm" />
          </BreadcrumbItem>
        </>
      )}
    </Breadcrumb>
  );
}
